import Svg, { SvgProps, Path } from 'react-native-svg';

const SelectIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M14.961 25.713a.722.722 0 0 1-.511-.212l-7.238-7.238a.724.724 0 0 1 .512-1.235h14.475a.723.723 0 0 1 .512 1.236L15.473 25.5a.721.721 0 0 1-.512.212ZM14.962 4c.185 0 .37.07.511.212l7.238 7.238a.724.724 0 0 1-.512 1.235H7.724a.723.723 0 0 1-.512-1.235l7.238-7.238A.722.722 0 0 1 14.962 4Z" />
  </Svg>
);

export default SelectIcon;
